import React, { FC } from 'react';
import { useFormState } from 'react-final-form';
import { ProgressBar } from '../../../components';
import { ProgressBarSection } from '../../../types/shopConfig/shopConfigV2';
import { useItemDetailsFormSections } from '../../../hooks/useItemDetailsFormSections';
import {
  getProgressBarCompletionStates,
  getRelevantSections,
} from './ListingFlowProgressBar.utils';

const SearchProgressBar: FC = () => {
  const formState = useFormState();
  const getItemDetailsFormSectionsToShow = useItemDetailsFormSections();
  const searchFormSectionsToShow = getItemDetailsFormSectionsToShow();
  const relevantSections = getRelevantSections(searchFormSectionsToShow);
  const findItemSection = ProgressBarSection.FindItem;
  const findItemComplete = formState.valid ? [findItemSection] : [];
  const progressBarSections = getProgressBarCompletionStates(relevantSections, findItemComplete);

  if (!progressBarSections.length) {
    return null;
  }

  return <ProgressBar displayedSections={progressBarSections} />;
};

export default SearchProgressBar;
